export default __webpack_public_path__ + "images/hispatec-track-white.svg";